export default {
    root: 'https://www.ncu.edu.jm/manage/wp-json/wp/v2/',
    careers: []    
}